<ng-container *ngIf="canBatchSelect; then complex; else simple"></ng-container>

<ng-template #simple>
    <div class="sh-form-check">
        <input
            type="checkbox"
            id="'action-mode-checkbox'"
            [formControl]="checkboxControl"
            [indeterminate]="isIndeterminate$ | async"
            class="sh-checkbox sh-form-check__input"
        />
        <label for="selection-checkbox" class="sh-form-check__label -sh-on-dark">{{ selectedItemsLabel$ | async }}</label>
    </div>
</ng-template>

<ng-template #complex>
    <div class="sh-form-check-dropdown-wrapper" (shClickOutside)="setDropdownClosed()" id="action-mode-dropdown">
        <sh-droppanel-select
            [id]="'action-mode-dropdown'"
            [options]="dropdownOptions"
            [initialSelectedValues]="initialSelectedDropdownValues"
            [allowSingleDeselect]="false"
            [isOpen$]="isOpen$"
            (selectionState)="onSelectionStateChange($event)"
        >
            <div class="sh-form-check-with-icon--inverted">
                <div class="sh-form-check-with-icon__check" (click)="toggleDropdown($event)" (keydown.enter)="toggleDropdown($event)">
                    <input
                        #checkboxEl
                        type="checkbox"
                        [formControl]="checkboxControl"
                        id="'action-mode-checkbox'"
                        class="sh-checkbox sh-form-check-with-icon__check__input sh-form-group__input"
                        [shIndeterminate]="isIndeterminate$ | async"
                    />
                    <svg sh-icon class="sh-form-check-with-icon__check__icon" [name]="'angle-down'" [size]="'small'" aria-hidden="true"></svg>
                </div>
                <label *ngIf="selectedItemsLabel$ | async as label" [for]="'action-mode-checkbox'" class="sh-form-check-with-icon__label">{{ label }}</label>
            </div>
        </sh-droppanel-select>
    </div>
</ng-template>
